import classNames from "classnames";

import "./stepper.css";

interface IProps {
  steps: number[];
  currentStep: number;
  classes?: string;
}
export function Stepper({ steps = [], currentStep, classes = "" }: IProps) {
  return (
    <div className={`stepper-wrapper mx-auto ${classes}`}>
      {steps.map((step, idx) => (
        <div
          key={idx}
          className={classNames("stepper-item", {
            completed: step <= currentStep,
            active: currentStep === step
          })}
        >
          <div className="step-counter">{idx + 1}</div>
          {/* {step?.label ? <div className="step-name">{step.label}</div> : null} */}
        </div>
      ))}
    </div>
  );
}
